import { render, staticRenderFns } from "./DrawerIndex.vue?vue&type=template&id=449c2568"
import script from "./DrawerIndex.vue?vue&type=script&lang=js"
export * from "./DrawerIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports